import React, { forwardRef } from 'react';
import {
  TextField,
  InputAdornment,
  MenuItem,
  Select,
  RadioGroup,
  Radio,
  FormControlLabel,
  FormControl,
  Box,
  Checkbox,
  Card,
  useTheme,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
import { DatePicker } from '@material-ui/lab';
import { Controller } from 'react-hook-form';
import ImageUploading from 'react-images-uploading';
import ClearIcon from '@material-ui/icons/Clear';
// import UpdateIcon from '@material-ui/icons/Update';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import Cascade from '@/components/cascader_ml/CascaderMl';
import AntdTree from '@/components/AntdTree/AntdTree';
import ClearIconML from '@/components/ClearIconML/index';
import Styled from './styled';

const initErrorStyle = {
  color: '#f44336',
  margin: 0,
  fontSize: '0.75rem',
  marginTop: '-8px',
  textAlign: 'left',
  fontWeight: '400',
  lineHeight: '1.66',
  letterSpacing: '0.03333em',
};
const errorText = ({ errors, name, label, helperText, rules }) => {
  const maxLength = rules?.maxLength;
  if (errors && errors[name]) {
    const { type } = errors[name];
    switch (type) {
      case 'required':
        return `${label}是必填项`;
      case 'maxLength':
        return `输入不超过${maxLength}个字符`;
      default:
        return helperText;
    }
  }
};
export const TextFieldCom = forwardRef(
  (
    {
      queryType,
      control,
      label,
      showLabel = true,
      helperText = '',
      isPositiveNumber = false,
      endAdornment = null,
      isParseInt = false,
      initLabel,
      name,
      rules,
      errors,
      setValue,
      className,
      initHeight,
      isNumber,
      showError = true,
      setFieldValue,
      parameter,
      realName,
      multiline = false,
      maxRows = 4,
      minRows = 4,
      ...props
    },
    ref,
  ) => {
    const onKeyDown = (e) => {
      if (e.keyCode === 13 && !multiline) {
        const tagName = e.target.tagName.toLowerCase();
        if (tagName === 'input') {
          e.preventDefault();
        }
      }
    };
    return (
      <Box sx={{ width: '100%' }}>
        {initLabel && (
          <Box
            sx={{
              fontSize: 12,
              color: '#212100',
              marginBottom: '8px',
            }}
          >
            {rules?.required && <span style={{ color: 'red' }}>*</span>}
            {label}
          </Box>
        )}
        <Controller
          render={(pr) => (
            <TextField
              sx={{ width: '100%', ...initHeight }}
              ref={ref}
              variant="standard"
              multiline={multiline}
              maxRows={maxRows}
              minRows={minRows}
              label={
                showLabel && label ? (
                  <>
                    {rules?.required && <span style={{ color: 'red' }}>*</span>}{' '}
                    {label}
                  </>
                ) : (
                  ''
                )
              }
              {...props}
              className={className}
              onChange={(e) => {
                let v = e.target.value;
                if (isNumber) {
                  const f = v.charAt(0);
                  if (f === '-') {
                    const n = v.substr(1, v.length);
                    if (isNaN(n)) {
                      v = '';
                    }
                  } else if (isNaN(v)) {
                    v = '';
                  }
                  if (isPositiveNumber) {
                    v = v.replace(/-/g, '');
                  }
                  if (isParseInt) {
                    // eslint-disable-next-line radix
                    v = v.replace(/\D/g, '');
                  }
                }
                setFieldValue &&
                  setFieldValue({
                    ...parameter,
                    value: v,
                    realName,
                  });
                return pr.onChange(v);
              }}
              onKeyDown={onKeyDown}
              // onBlur={(e) => {}}
              error={showError && errors && Boolean(errors[name])}
              helperText={
                showError
                  ? errorText({ errors, name, label, helperText, rules })
                  : ''
              }
              disabled={queryType === 'detail'}
              value={pr.value ?? ''}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      className="clear-btn"
                      onClick={() => {
                        setValue(name, '');
                        setFieldValue &&
                          setFieldValue({
                            ...parameter,
                            value: '',
                            realName,
                          });
                      }}
                      edge="end"
                      disabled={queryType === 'detail'}
                    >
                      {pr.value && <ClearIcon className="clear-icon" />}
                    </IconButton>
                    {endAdornment && (
                      <span
                        style={{
                          fontSize: '12px',
                          color: '#404041',
                          marginLeft: '4px',
                        }}
                      >
                        {endAdornment}
                      </span>
                    )}
                  </InputAdornment>
                ),
              }}
            />
          )}
          control={control}
          name={name}
          rules={rules}
        />
      </Box>
    );
  },
);

export const SelectFieldCom = forwardRef(
  (
    {
      queryType,
      typeList = [],
      label,
      disabled,
      initLabel,
      defaultValue = '',
      control,
      name,
      rules,
      errors,
      setValue,
      getValues = () => {},
      showError = false,
      fieldNames = { label: 'name', value: 'value' },
      setFieldValue,
      parameter,
      realName,
      placeholder,
      multiple,
      ...props
    },
    ref,
  ) => {
    return (
      <Box
        position="relative"
        bottom={queryType !== 'detail' ? '-4px' : 0}
        flex="1"
        width="100%"
        display="flex"
      >
        {initLabel && (
          <Box sx={{ fontSize: 12, color: '#212100', marginBottom: '12px' }}>
            <span style={{ color: 'red' }}>*</span>
            {label}
          </Box>
        )}
        <Box className="display-row" sx={{ width: '100%' }}>
          <FormControl sx={{ width: '100%', height: 'auto' }}>
            <Controller
              render={(pr) => {
                const v = pr.value ?? defaultValue;
                let mv = v;
                if (multiple) {
                  mv = v?.split(',') || [];
                }
                return (
                  <Select
                    variant="standard"
                    displayEmpty
                    sx={{ width: '100%' }}
                    ref={ref}
                    {...props}
                    disabled={queryType === 'detail' || disabled}
                    onChange={(e) => {
                      let cv = e.target.value;
                      if (multiple && cv) {
                        cv = cv.filter((item) => item !== '').join();
                      }
                      setFieldValue &&
                        setFieldValue({
                          ...parameter,
                          value: cv,
                          realName,
                        });
                      return pr.onChange(cv);
                    }}
                    value={mv}
                    label={label ? label : ''}
                    multiple={multiple}
                    renderValue={(selected) => {
                      if (
                        !selected ||
                        (selected &&
                          selected.length === 1 &&
                          selected[0] === '')
                      ) {
                        return (
                          <span
                            style={{ color: 'currentColor', opacity: '0.42' }}
                          >
                            {placeholder}
                          </span>
                        );
                      }
                      if (
                        typeList &&
                        Array.isArray(typeList) &&
                        typeList.length > 0
                      ) {
                        if (multiple) {
                          const s = typeList.filter(
                            (item) =>
                              selected.indexOf(item[`${fieldNames.value}`]) >
                              -1,
                          );
                          return s.map((i) => i[fieldNames.label]).join();
                        }
                        const s = typeList.find(
                          (item) => item[`${fieldNames.value}`] === selected,
                        );
                        return s ? s[`${fieldNames.label}`] : '';
                      }
                      return '';
                    }}
                  >
                    <MenuItem disabled value="">
                      {placeholder}
                    </MenuItem>
                    {typeList.map((item) => (
                      <MenuItem
                        key={item[`${fieldNames.value}`]}
                        value={item[`${fieldNames.value}`]}
                      >
                        {item[`${fieldNames.label}`]}
                      </MenuItem>
                    ))}
                  </Select>
                );
              }}
              label=""
              name={name}
              control={control}
              rules={rules}
            />
            <ClearIconML
              handleClick={() => {
                setFieldValue &&
                  setFieldValue({
                    ...parameter,
                    value: '',
                    realName,
                  });
                setValue(name, '');
              }}
              clearValue={!disabled && getValues(name)}
            ></ClearIconML>
            {showError && Boolean(errors[name]) && (
              <FormHelperText
                error={Boolean(errors[name])}
              >{`${label}是必选项`}</FormHelperText>
            )}
          </FormControl>
        </Box>
      </Box>
    );
  },
);

export const RadioFieldCom = forwardRef(
  (
    {
      queryType,
      control,
      typeList = [],
      lWidth,
      children,
      row = true,
      name,
      initLabel,
      label,
      defaultVal = '',
      ...props
    },
    ref,
  ) => {
    return (
      <Box>
        {initLabel && (
          <Box sx={{ fontSize: 12, color: '#212100', marginBottom: '12px' }}>
            <span style={{ color: 'red' }}>*</span>
            {label}
          </Box>
        )}
        <Box className="display-row">
          <Controller
            render={(pr) => (
              // <RadioFieldCom
              //   pr={pr}
              //   id="miniprogramNotice"
              //   queryType={queryType}
              //   typeList={typeListRadios7}
              //   lWidth="auto"
              // />
              <RadioGroup
                aria-label="gender"
                {...props}
                {...pr}
                value={pr.value ?? defaultVal}
                ref={ref}
                onChange={(e) => {
                  return pr.onChange(e.target.value);
                }}
                row={row}
                sx={{ gap: '0 48px' }}
                className="checkbox-radio-disabled-color"
              >
                {typeList.map((item, index) => (
                  <Box>
                    <FormControlLabel
                      key={index}
                      sx={{
                        minWidth:
                          index === typeList.length - 1 && lWidth
                            ? lWidth
                            : '102px',
                      }}
                      disabled={queryType === 'detail' || item.disabled}
                      value={item.value}
                      control={<Radio />}
                      label={
                        queryType === 'detail' || item.disabled ? (
                          item.label
                        ) : (
                          <span style={{ color: '#212121' }}>{item.label}</span>
                        )
                      }
                    />
                    {Array.isArray(children) &&
                      children.length > 0 &&
                      children[index]}
                  </Box>
                ))}
              </RadioGroup>
            )}
            name={name}
            control={control}
          />
        </Box>
      </Box>
    );
  },
);

export const CheckBoxFieldCom = forwardRef(
  (
    {
      control,
      queryType,
      name,
      label,
      defaultValue = false,
      onCallBack,
      resetPrize,
      guid,
      restKey,
      ...props
    },
    ref,
  ) => {
    return (
      <Styled>
        <Box className="checkbox-radio-disabled-color">
          <Controller
            render={(pr) => (
              <FormControlLabel
                ref={ref}
                {...props}
                {...pr}
                variant="standard"
                checked={pr.value ?? defaultValue}
                control={<Checkbox color="primary" />}
                label={label && <Box color="#000">{label}</Box>}
                onChange={(e) => {
                  onCallBack && onCallBack(e);
                  resetPrize && resetPrize(guid, restKey, e.target.checked);
                  pr.onChange(e.target.checked);
                }}
                disabled={queryType === 'detail'}
              />
            )}
            name={name}
            control={control}
            defaultValue={defaultValue}
          />
        </Box>
      </Styled>
    );
  },
);

export const UploadImageCom = forwardRef(
  (
    {
      multiple = false,
      uW = '120',
      uH = '120',
      iW = '120',
      iH = 'auto',
      maxNumber = 9,
      images = [],
      handleSetImages,
      label,
      required = false,
      tips,
      tipsAlign = 'left',
      handlePreview,
      queryType,
      acceptType = ['png'],
    },
    ref,
  ) => {
    const theme = useTheme();
    const onChange = (imageList) => {
      // data for submit
      handleSetImages(imageList);
    };
    return (
      <Box ref={ref} sx={{ width: '100%' }}>
        {label && (
          <Box mb={2} color="#212100" fontSize="12px">
            {required && <span style={{ color: 'red' }}>*</span>} {label}
          </Box>
        )}
        <ImageUploading
          multiple={multiple}
          value={images}
          onChange={onChange}
          maxNumber={maxNumber}
          dataURLKey="data_url"
          acceptType={acceptType}
        >
          {({
            // imageList,
            onImageUpload,
            // onImageRemoveAll,
            onImageUpdate,
            // onImageRemove,
            // isDragging,
            dragProps,
          }) => (
            // write your building UI
            <Box sx={{ width: '100%', height: '100%' }}>
              {images.length === 0 && queryType !== 'detail' && (
                <Box
                  sx={{
                    width: `${uW}px`,
                    height: `${uH}px`,
                    background: '#F5F5F5',
                    borderRadius: '4px',
                    border: '1px solid #CCCCCC',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                  onClick={onImageUpload}
                  {...dragProps}
                >
                  {/* <img src={AddPhoto} alt="" width="38" /> */}
                  {/* <AddPhoto sx={{ width: '38px', height: '38px' }} /> */}
                  <SvgIconML
                    name="add_photo_alternate"
                    size={38}
                    className="preview"
                  />
                </Box>
              )}
              {images.map((image, index) => (
                <Box
                  key={index}
                  className="upload-image-item"
                  sx={{
                    width: `${iW}px`,
                    height: `${iH}px`,
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '4px',
                    border: '1px solid #cccccc',
                    padding: '4px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <img
                    src={image['data_url']}
                    alt=""
                    style={{ maxWidth: '100%', maxHeight: '100%' }}
                  />
                  <Card className="montmorillonite-layer-wrap"></Card>
                  <Card className="montmorillonite-layer-in">
                    <Box className="icon-wrap">
                      <IconButton
                        className="icon-button"
                        aria-label="edit"
                        onClick={() => handlePreview(images)}
                        //  onClick={onEdit}
                      >
                        <SvgIconML
                          name="imgPreview"
                          size={24}
                          fill={theme.palette.primary.main}
                        />
                      </IconButton>
                    </Box>
                    {queryType !== 'detail' && (
                      <Box className="icon-wrap">
                        {/* <UpdateIcon
                        size={24}
                          className="icon-style"
                          onClick={() => onImageUpdate(index)}
                        /> */}
                        <IconButton
                          className="icon-button"
                          aria-label="edit"
                          onClick={() => onImageUpdate(index)}
                        >
                          <SvgIconML
                            name="updateImg"
                            size={24}
                            fill={theme.palette.primary.main}
                          />
                        </IconButton>
                      </Box>
                    )}
                  </Card>
                </Box>
              ))}
            </Box>
          )}
        </ImageUploading>
        {tips && queryType !== 'detail' && (
          <Box mt={0.5} color="#999999" fontSize="12px" textAlign={tipsAlign}>
            {tips}
          </Box>
        )}
      </Box>
    );
  },
);

export const CascadeFieldCom = forwardRef(
  (
    {
      label,
      setValue,
      name,
      realName,
      queryType,
      cascadeData,
      control,
      rules,
      showLabel,
      fieldNames,
      errors,
      setError,
      clearErrors,
      nameMessage,
      setFieldValue,
      parameter,
      isShowSearch,
      showError = true,
      placeholder,
      width = 200,
      isDisplayRender,
      onCallBack = () => {},
    },
    ref,
  ) => {
    const handleChangePca = (value, selectedItem) => {
      setValue(
        name,
        selectedItem && Array.isArray(selectedItem) && selectedItem.length > 0
          ? selectedItem
          : '',
      );
      if (rules) {
        if (
          !selectedItem ||
          (selectedItem &&
            Array.isArray(selectedItem) &&
            selectedItem.length === 0)
        ) {
          setFieldValue && setFieldValue({ ...parameter, value: [], realName });
          setError(name, {
            type: 'required',
          });
        } else {
          setFieldValue &&
            setFieldValue({ ...parameter, value: selectedItem, realName });
          clearErrors([name]);
        }
      }

      onCallBack({ value, selectedItem });
    };
    return (
      <Box ref={ref} width={width}>
        {showLabel && (
          <Box
            sx={{
              fontSize: 12,
              color: '#212100',
              marginBottom: '-8px',
            }}
          >
            {rules?.required && <span style={{ color: 'red' }}>*</span>}
            {label}
          </Box>
        )}
        <Controller
          name={name}
          control={control}
          as={
            <Cascade
              label={label}
              cascadeData={cascadeData}
              disabled={queryType === 'detail'}
              handleChangePca={handleChangePca}
              fieldNames={fieldNames}
              isShowSearch={isShowSearch}
              initStatus={true}
              placeholder={placeholder}
              isDisplayRender={isDisplayRender}
            />
          }
          rules={rules}
        />
        {showError && errors[name] && (
          <Box sx={{ ...initErrorStyle, marginTop: '8px' }}>
            {errors[name] ? nameMessage : ''}
          </Box>
        )}
      </Box>
    );
  },
);

export const AntdTreeFieldCom = forwardRef(
  (
    {
      showLabel,
      rules,
      label,
      name,
      control,
      queryType,
      fieldNames,
      treeData,
      setValue,
      errors,
      setError,
      clearErrors,
      nameMessage,
      placeholder,
      treeNodeAdd,
      canVisibleChange = true,
    },
    ref,
  ) => {
    const selectValueSet = (keys) => {
      setValue(name, keys.length > 0 ? keys[0] : '');
      if (!keys || (keys && Array.isArray(keys) && keys.length === 0)) {
        setError(name, {
          type: 'required',
        });
      } else {
        clearErrors([name]);
      }
    };
    return (
      <Box ref={ref}>
        {showLabel && (
          <Box
            sx={{
              fontSize: 12,
              color: '#212100',
              marginBottom: '8px',
            }}
          >
            {rules?.required && <span style={{ color: 'red' }}>*</span>}
            {label}
          </Box>
        )}
        <Controller
          name={name}
          control={control}
          as={
            <AntdTree
              treeData={treeData}
              fieldNames={fieldNames}
              disabled={queryType === 'detail'}
              selectValueSet={selectValueSet}
              placeholder={placeholder}
              errors={errors}
              treeNodeAdd={treeNodeAdd}
              canVisibleChange={canVisibleChange}
            />
          }
          rules={rules}
        />
        {errors[name] && (
          <Box sx={{ ...initErrorStyle, marginTop: 0 }}>
            {errors[name] ? nameMessage : ''}
          </Box>
        )}
      </Box>
    );
  },
);

export const DatePickerCom = forwardRef(
  (
    {
      showLabel,
      rules,
      label,
      name,
      control,
      queryType,
      setValue,
      errors,
      // setError,
      // clearErrors,
      nameMessage,
      showError = true,
      setFieldValue,
      parameter,
      defaultValue,
      realName,
    },
    ref,
  ) => {
    setValue(name, defaultValue);
    return (
      <Box
        ref={ref}
        position="relative"
        bottom={queryType !== 'detail' ? '-4px' : 0}
      >
        {showLabel && (
          <Box
            sx={{
              fontSize: 12,
              color: '#212100',
              marginBottom: '8px',
            }}
          >
            {rules?.required && <span style={{ color: 'red' }}>*</span>}
            {label}
          </Box>
        )}
        <Controller
          name={name}
          control={control}
          as={(pr) => {
            return (
              <DatePicker
                label={label}
                inputFormat="yyyy-MM-dd" //时间格式化
                value={pr.value ?? defaultValue}
                // eslint-disable-next-line no-unused-vars
                onAccept={(newValue) => {
                  const m =
                    newValue.getMonth() + 1 < 10
                      ? '0' + (newValue.getMonth() + 1)
                      : newValue.getMonth() + 1;
                  const d =
                    newValue.getDate() < 10
                      ? '0' + newValue.getDate()
                      : newValue.getDate();
                  const date = newValue.getFullYear() + '-' + m + '-' + d;
                  setFieldValue &&
                    setFieldValue({ ...parameter, value: date, realName });
                }}
                disabled={queryType === 'detail'}
                onChange={() => {}}
                renderInput={(params) => {
                  return (
                    <Box>
                      <TextField
                        sx={{
                          height: 'auto',
                          display: 'flex',
                          alignItems: 'flex-end',
                        }}
                        variant="standard"
                        {...params}
                        inputProps={{
                          ...params.inputProps,
                          placeholder: '请选择时间',
                          readonly: 'readonly',
                        }}
                      />
                    </Box>
                  );
                }}
              />
            );
          }}
          rules={rules}
        />
        {showError && errors[name] && (
          <Box sx={initErrorStyle}>{errors[name] ? nameMessage : ''}</Box>
        )}
      </Box>
    );
  },
);
